import { render, staticRenderFns } from "./PgaActivitiesList.vue?vue&type=template&id=36e876f8&"
import script from "./PgaActivitiesList.vue?vue&type=script&lang=ts&"
export * from "./PgaActivitiesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36e876f8')) {
      api.createRecord('36e876f8', component.options)
    } else {
      api.reload('36e876f8', component.options)
    }
    module.hot.accept("./PgaActivitiesList.vue?vue&type=template&id=36e876f8&", function () {
      api.rerender('36e876f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Shared/Activity/Components/PgaActivitiesList.vue"
export default component.exports